<template>
  <div class="container-fluid">
    <Card back>
      <template v-slot:header>
        <h3>پانل ارســال پیـــامک</h3>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <!-- جستوجو و نمایش کاربر -->
          <div class="p-2 col-md-9 col-12">
            <div class="col-12">
              <div class="row">
                <div id="TblComboIdVazeit12" class="col-md-3 col-12 mt-2">
                  <small>وضعیت مشتری</small>
                  <SearchableCombo :edit="false" :queryString="{ id: 12 }" :code="null" @ResultCombo="ValueResultVaziat" :rownumintable="3" :action="'TblCombo/GettblCombo'" :method="'GET'" :idinput="'Vaziat'" :keyItem="'Vaziat'" :disabled="false"> </SearchableCombo>
                  <!-- <combo :IsDisabled="false"   :IsDefault="true" :Params="12" :IdEditMode="0" :IsLoad="true" :Op_TextDefult="'وضعیت را انتخاب کنید'"></combo> -->
                </div>
                <div id="TblTafsiliTypeId" class="col-md-3 col-12 mt-2">
                  <small>نوع مشتری </small>
                  <!-- <combo :IdEl="''" :IsDefault="false" :IdEditMode="0" :IsDisabled="false" :IsLoad="true" :ActionUrl="'GettblTafsiliType'" :Params="$session.get('UserInfo').tblShobeId" :Op_TextDefult="'نوع مشتری را انتخاب کنید'"></combo> -->
                  <SearchableCombo :edit="false" :queryString="{ id: $session.get('UserInfo').tblShobeId }" :code="null" @ResultCombo="ValueResultNoeMoshtari" :rownumintable="3" :action="'TblCombo/GettblTafsiliType'" :method="'GET'" :idinput="'NoeMoshtar'" :keyItem="'NoeMoshtar'" :disabled="false">
                  </SearchableCombo>
                </div>
                <div id="ShomareOzv" class="col-md-2 col-10 mt-2">
                  <small>کد مشتری</small>
                  <input v-model="DataAxios.ArryfildValue.ShomareOzv" type="text"  @keydown="SearchShomareozv($event)" :placeholder="$session.get('UserInfo').codeShobe.trim() + '-'" class="form-control" dir="ltr" />
                </div>
                <div id="ShomareOzv" class="col-md-1 pt-2 pr-0 col-2 mt-2 text-right">
                  <button type="button" tabindex="-1" class="btn btn-outline-success mt-3" @click.prevent="OpenModal(1)" data-toggle="modal" data-target="#Modal-Success" dir="ltr">
                    <span class="fa fa-list mt-2" tabindex="-1"></span>
                  </button>
                </div>
                <div id="TblAzaNoeId" class="col-md-3 col-12 mt-2">
                  <small>حوزه </small>
                  <!-- <combo :IsDefault="true" :IdEl="''" :IdEditMode="0" @ValueResult="ValueResultHoze" :IsDisabled="false" :IsLoad="true" :ActionUrl="'GetHoze'" :Params="$session.get('UserInfo').tblShobeId" :Op_TextDefult="'حوزه را انتخاب کنید'"></combo> -->
                  <SearchableCombo :edit="false" :queryString="{ id: $session.get('UserInfo').tblShobeId }" :code="null" @ResultCombo="ValueResultHoze" :rownumintable="3" :action="'TblCombo/GetHoze'" :method="'GET'" :idinput="'Hoze'" :keyItem="'Hoze'" :disabled="false"> </SearchableCombo>
                </div>
                <!-- <div id="TblTaahodatId" class="col-md-2 col-12 mt-2">
                  <small>حساب | تسـهیلات</small>
                  <input type="text" v-mask="$Get_FormatVcode()" v-model="VCodeTaahodat" :placeholder="$session.get('UserInfo').codeShobe.trim() + '-' + '__-'" @unfocus="GetTaahodat($event)" @keydown="SearchTaahod($event)" class="form-control" dir="ltr" />
                </div>
                <div id="TblTaahodatId" class="col-md-1 pt-2 pr-0 col-2 mt-2 text-right">
                  <button type="button" tabindex="-1" class="btn btn-outline-success mt-3" @click.prevent="OpenModal(2)" data-toggle="modal" data-target="#Modal-Success" dir="ltr">
                    <span class="fa fa-list mt-2" tabindex="-1"></span>
                  </button>
                </div> -->
                <div id="Mobile" class="col-md-3 col-2 mt-1 text-right">
                  <small>تلفن همراه </small>
                  <input v-model="DataAxios.ArryfildValue.Mobile" type="text" @keypress="$ValidNumber($event, 11)" class="form-control text-left" />
                </div>
                <div id="OzvName" class="col-md-3 col-2 mt-1 text-right">
                  <small>نام </small>
                  <input v-model="DataAxios.ArryfildValue.OzvName" type="text" @keypress="$ValidPersian($event, 15)" class="form-control" />
                </div>
                <div id="OzvFamily" class="col-md-3 col-2 mt-1 text-right">
                  <small> نام خانوادکی </small>
                  <input v-model="DataAxios.ArryfildValue.OzvFamily" type="text" @keypress="$ValidPersian($event, 25)" class="form-control" />
                </div>
                <div class="col-md-3 col-2 mt-1 mt-4 text-right">
                  <button class="btn btn-success w-100" @click.prevent="Search">
                    <span class="mr-2">جستجــو مشتری</span>&nbsp;
                    <span class="fa fa-search"></span>
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 col-12">
                  <div class="row border-t-b mt-2">
                    <div class="col-md-8 col-12 text-center">
                      تعداد <span class="text-orange font-weight-bold" style="font-size: 20px !important">{{ SelectedAza.length }}</span> عضو برای ارسال پیامک انتخاب هستند .
                    </div>
                    <div class="col-md-4 col-12 text-center">
                      <div class="row my-1">
                        <div class="col-md-6 col-12">
                          <button style="font-size: xx-small !important" v-if="rows.length > 0" class="btn w-100 px-1 btn-success font-weight-normal p-1 animated animate__animated animate__jackInTheBox" @click="SelectAll()"><i class="fas fa-check ml-2"></i>انتخاب همه</button>
                        </div>
                        <div class="col-md-6 col-12">
                          <button style="font-size: xx-small !important" v-if="SelectedAza.length > 0" class="btn w-100 px-1 btn-warning font-weight-normal p-1 animated animate__animated animate__jackInTheBox" @click="UnSelectAll()"><i class="fas fa-times ml-2"></i>حذف انتخاب ها</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row p-2">
                    <div class="col-12">
                      <BnpGrid :key="GridKey" :propsRows="rows" :propsColumn="columns" :action="true">
                        <template slot="Done" slot-scope="props" class="text-center">
                          <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input InputText" :checked="props.cell_value" id="Done" disabled />
                            <label class="custom-control-label" for="Done"></label>
                          </div>
                        </template>
                        <template slot="action-slot" slot-scope="props">
                          <a href="javascript:void(0)" v-if="props.props.Selected && props.props.Mobile != ''" class="btn px-3 btn-secondary font-weight-normal p-1 m-1" @click="UnSelectRow(props.props)"><i class="fas fa-times ml-2"></i> حذف</a>
                          <a href="javascript:void(0)" v-else-if="!props.props.Selected && props.props.Mobile != ''" class="btn px-3 btn-secondary font-weight-normal p-1 m-1" @click="SelectRow(props.props)"><i class="fas fa-check ml-2"></i>انتخاب </a>
                          <a href="javascript:void(0)" v-else-if="props.props.Mobile == ''" class="btn px-3 btn-dark font-weight-normal p-1 m-1" @click="SelectNotMobile(props.props, false)"><i class="fas fa-times ml-2"></i>انتخاب </a>
                        </template>
                      </BnpGrid>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- نمایش پیامک و تنظیماتش -->
          <div class="col-md-3 col-12">
            <div class="row">
              <div class="col-1"></div>
              <div class="col-10 image text-left position-relative" :style="Img()">
                <div id="Nav" class="col-12 Up border-bottom pb-4 text-center mt-5" z-index="1000">
                  <i class="text-light">{{ SmsNumber }}</i>
                  <i class="fas fa-battery-quarter text-light fl-0" style="float: right"></i>
                  <i class="fas fa-signal text-light fl-0" style="float: left"></i>
                  <div>
                    <i v-if="IsUp == true" id="fa" class="fas fa-angle-down text-orange Pointer" @click="Down" style="font-size: 15px"></i>
                    <i v-else id="fa" class="fas fa-angle-up text-orange Pointer" @click="Up" style="font-size: 15px"></i>
                  </div>
                  <div v-if="!IsUp == true" class="bg-secondary">
                    <div
                      @click="
                        Ani = !Ani
                        Tarikh = ''
                        Up()
                        Anii()
                      "
                      :title="Ani == true ? 'ارسال آنی فعال می باشد' : 'ارسال آنی غیر فعال می باشد'"
                      :class="Ani == true ? 'bg-primary' : 'bg-secondary'"
                      class="btn-circle position-absolute text-light Pointer animate__animated animate__fadeInUp"
                      style="bottom: 10px; left: 57px; width: 30px; height: 30px"
                    >
                      <i class="fas fa-bolt"></i>
                    </div>
                    <div
                      title="ارســال متفرقه"
                      @click="
                        Motofareghe = !Motofareghe
                        Up()
                      "
                      :class="Motofareghe == true ? 'bg-primary' : 'bg-secondary'"
                      class="btn-circle position-absolute text-light animate__animated animate__fadeInUp Pointer"
                      style="bottom: 10px; left: 107px; width: 30px; height: 30px"
                    >
                      <i class="fas fa-user-plus"></i>
                    </div>
                    <!-- <div
                      @click="
                        PreviewMsg(true)
                        Up()
                      "
                      :class="Preview == true ? 'bg-primary' : 'bg-secondary'"
                      title="پیش نمایــش"
                      class="btn-circle position-absolute text-light animate__animated animate__fadeInUp Pointer"
                      style="bottom: 10px; left: 157px; width: 30px; height: 30px"
                    >
                      <i class="fas fa-glasses" aria-hidden="true"></i>
                    </div> -->
                  </div>
                </div>
                <div id="Combo" z-index="5" class="col-12 mx-0 text-center Show">
                  <input v-if="Motofareghe == true" value=": شماره همراه " rows="5" type="text" @keypress="$ValidPersian($event, 100)" class="form-control text-left To" v-model="PhoneNum" />
                  <div v-if="!Ani == true" class="mt-2">
                    <small class="text-light font-weight-normal">تاریخ و ساعت ارسال پیامک</small>
                    <date-picker :editable="true" color="#ff9800" v-model="Tarikh" type="datetime" input-class="To" />
                  </div>
                  <!-- <combo :IsDefault="false" :IdEl="''" :IdEditMode="0" :IsDisabled="false" :classs="'To d-none'" :IsLoad="true" :ActionUrl="'GetHoze'" :Params="$session.get('UserInfo').tblShobeId" :Op_TextDefult="'حوزه را انتخاب کنید'"></combo> -->
                  <!-- <SearchableCombo :edit="false" :queryString="{ id: $session.get('UserInfo').tblShobeId }" :code="null" @ResultCombo="ValueResultHoze" :rownumintable="3" :action="'TblCombo/GetHoze'" :method="'GET'" :idinput="'HozeM'" :keyItem="'HozeM'" :disabled="false"> </SearchableCombo> -->

                  <!-- <combo  :IsDefault="false" :IdEl="''"  :IdEditMode="0"  :IsDisabled="false" :Class="'To'" :IsLoad="true" :ActionUrl="'GetHoze'" :Params="$session.get('UserInfo').tblShobeId" :Op_TextDefult="'حوزه را انتخاب کنید'"></combo> -->
                  <select v-model="TextSmsTemplate" class="form-control To mt-3 text-center Pointer" @click="GetListSmsTemplate" style="max-height: 100px !important" @change="changeSmsTemplate">
                    <option selected value="">-- پیامــک های آماده --</option>
                    <option v-for="(itemSms, key) in ListSms" :key="key" :value="itemSms.MatnSMS">
                      {{ itemSms.Onvan }}
                    </option>
                  </select>
                </div>
                <div class="row mt-3">
                  <div class="col-12 text-center">
                    <small class="text-light font-weight-normal">
                      تاریخ ارسال: <span>{{ Ani == true && Tarikh == '' ? $GetJalaliDateTime() : Tarikh }}</span></small
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 text-right">
                    <img class="rounded-circle UserImage" src="/img/pic/MoshtariPic.jpg" alt="First slide" />
                  </div>
                  <div class="col-12 mt-1 text-left pr-2 pl-2">
                    <textarea id="cin" v-model="TextSmsTemplate" class="Box-Message p-2 w-100 mx-0"> </textarea>

                    <i class="fas fa-arrow-circle-left position-absolute text-warning Pointer" @click="SendSms" style="bottom: 8px; left: 20px; width: 30px; height: 30px; font-size: 25px"></i>
                    <!-- <i class="fas fa-arrow-left position-absolute text-warning" style="bottom:10px;left:20px; width:30px;  height:30px;font-size:23px;"></i> -->
                  </div>
                </div>
              </div>
              <div class="col-1"></div>
            </div>
          </div>
          <modal v-if="$store.state.Modal" :InheritanceTheme="true" :IsFooter="false" :Size="'Md'">
            <template v-slot:body>
              <div class="container text-right">
                <search-taahod v-if="ContentModal == 2" :NoRouteForm="'frmSearchTaahod'" @Taahod="GetTaahodSearched" :tblSarfaslTypeId="tblSarfaslTypeId"> </search-taahod>
                <search-aza v-if="ContentModal == 1" @OzvSelected="GetAzaSearched"></search-aza>
              </div>
            </template>
          </modal>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import Modal from '@/pages/Modal/Modal.vue'
import SearchTaahod from '@/pages/BnpCash/MnuOmorMali/SmnuHesabdari/SearchTaahod.vue'
import SearchAza from '@/components/BnpCash/SearchAza.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
export default {
  components: { BnpGrid, SearchableCombo, Card, Modal, SearchAza, SearchTaahod },
  data() {
    return {
      GridKey: 0,
      OzvInfo: null,
      ContentModal: 1,
      Data: [
        {
          SendSmsForHim: false,
          Id: 0,
          TblShobeId: 0,
          TblTafsiliTypeId: 0,
          TblAzaNoeId: 0,
          ShomareOzv: '',
          OzvName: '',
          OzvFamily: '',
          FamilyName: '',
          Mobile: '',
          TblComboIdVazeit12: 0,
          TblComboIdSex13: 0,
          WebPss: '',
          BirthDate: '',
          LastSmstavalod: '',
          CodeMeli: '',
          HamrahBankPass: '',
          XososiWeb: '',
          XososiHampa: '',
          TblTaahodatId: 0,
          Fkid: 0,
        },
      ],
      ListSms: [],
      checkedNames: [],
      VCodeTaahodat: '',
      DetailTaahodat: '',
      FamilyName: '',
      AzaSearch: false,
      Tarikh: '',
      Ani: true,
      Motofareghe: false,
      Preview: false,
      IsUp: true,
      TextSmsTemplate: '',
      DataAxoisColumns: {
        ArryfildValue: {
          SoftwareId: 2,
          UserId: 1,
          FormName: 'frmCashSmsPanel',
          ShowView: 0,
        },
        Method: 'post',
        Action: 'ReadGridColumns',
      },
      DataAxios_tblaza: {
        ArryfildValue: null,
        Method: 'Get',
        Action: 'AzaInfo',
      },
      DataAxios: {
        ArryfildValue: {},
      },
      rows: [],
      columns: [],
      config: {
        pagination: true,
        pagination_info: false,
        per_page_options: [5, 10, 20, 30],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: false,
        card_title: '',
        card_mode: false,
        selected_rows_info: false,
        global_search: {
          placeholder: ' جستجو',
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
          multi_column_sort: true,
        },
      },
      classes: {
        table: 'table-bordered table-striped table-sm',
      },
      SelectedAza: [],
      EmptyArr: [],
      PhoneNum: ': شماره همراه',
      CopyTextSms: '',
      FardMotofareghe: {
        tblAzaId: 0,
        tblShobeId: 0,
        XososiWeb: '',
        XososiHampa: '',
        XososiUssd: '',
        SendSmsForHim: true,
        ShomareOzv: '',
        FamilyName: '',
        Mobile: '',
        CodeMeli: '',
        MatnSMS: '',
        OzvFamily: '',
        OzvName: '',
        tblComboIdSex13: 0,
        WebPss: '',
        HamrahBankPass: '',
        UssdPass: '',
        row: 1,
        Selected: true,
        vbt_id: 1,
        TarixErsal: '',
        tblUserGrpInsert: 0,
        Ani: true,
      },
      SmsNumber: 0,
    }
  },
  created() {
    this.DataAxios.ArryfildValue = JSON.parse(JSON.stringify(this.Data[0]))
    this.DataAxios.ArryfildValue.TblShobeId = this.$session.get('UserInfo').tblShobeId
  },
  beforeMount() {
    this.columns = this.$NewGridColumns(this.DataAxoisColumns, true, false, true, true)
    this.$store.state.columns = this.columns
    this.GridKey++
  },
  methods: {
    Down() {
      var a = document.getElementById('Nav')
      a.classList.remove('Up')

      var b = document.getElementById('Nav')
      b.classList.add('Down')

      // var combos=document.getElementById("Combo");
      // combos.classList.remove("Show");

      // var combos1=document.getElementById("Combo");
      // combos1.classList.add("Hide");

      this.IsUp = false
    },
    Up() {
      var a = document.getElementById('Nav')
      a.classList.remove('Down')

      var b = document.getElementById('Nav')
      b.classList.add('Up')

      // var combos=document.getElementById("Combo");
      // combos.classList.remove("Hide");

      // var combos1=document.getElementById("Combo");
      // combos1.classList.add("Show");

      // var combos=document.getElementById("Combo");
      // combos.classList.remove("Combo");

      this.IsUp = true
    },
    changeSmsTemplate() {
      this.CopyTextSms = JSON.parse(JSON.stringify(this.TextSmsTemplate))

      if (this.Preview == true) {
        this.PreviewMsg(false).then((text) => {
          this.TextSmsTemplate = text
        })
      }
    },
    GetListSmsTemplate() {
      var DataAxiosSearch = { ArryfildValue: { ShobeId: 1, SoftwareId: 2 } }
      DataAxiosSearch.Action = 'SmsTemplate/GetSmsTemplate'
      DataAxiosSearch.Method = 'post'
      this.$PostData(DataAxiosSearch).then((data) => {
        if (data.status == 'Ok') {
          if (data.data.length > 0) {
            if (data.data[0].Id != null) {
              this.ListSms = data.data
            } else {
              this.ListSms = []
            }
          } else {
            alert('خطا')
          }
        }
      })
    },
    SendSms() {
      if (this.TextSmsTemplate == null || this.TextSmsTemplate == '') {
        this.$mySweetDefault('متن پیامی یافت نشد', 'متن پیامی برای ارسال ثبت نشده', 'warning', 2000)
      } else if (this.SelectedAza.length < 1) {
        if (this.PhoneNum.split(':')[0] == '') {
          this.$mySweetDefault('شماره یافت نشد', 'شماره ای برای ارسال پیامک یافت نشد', 'warning', 2000)
        } else {
          //حالت متفرقه
          var model = []

          model.push(JSON.parse(JSON.stringify(this.FardMotofareghe)))
          model[0].MatnSMS = this.TextSmsTemplate
          model[0].Mobile = this.PhoneNum.split(':')[0]
          model[0].TarixErsal = this.Ani == true ? this.$GetJalaliDateTime() : this.Tarikh
          model[0].tblUserGrpInsert = this.$session.get('UserInfo').tblGrpId
          model[0].Ani = this.Ani

          var DataAxiosReplaceSMSParameter = { ArryfildValue: { ListData: model } }
          DataAxiosReplaceSMSParameter.Action = 'CashSmsPanel/SendToTblSms'
          DataAxiosReplaceSMSParameter.Method = 'post'
          this.$PostData(DataAxiosReplaceSMSParameter).then((data) => {
            if (data.status == 'Ok') {
              this.$mySweetDefaultTost('عملیات موفق', 'پیامک ها با موفقیت به صف ارسال پیامک اضافه شدند', 'success', 2000)
              //ارسال همه پیامکهای آماده به ارسال
              this.$SendSmsAmadeha()
            }
          })
        }
      } else {
        //حالت انتخاب از جدول
        this.PreviewMsg(false).then((ArrMsg) => {
          this.SelectedAza = ArrMsg
          var DataAxiosReplaceSMSParameter = { ArryfildValue: { ListData: this.SelectedAza } }
          DataAxiosReplaceSMSParameter.Action = 'CashSmsPanel/SendToTblSms'
          DataAxiosReplaceSMSParameter.Method = 'post'
          this.$PostData(DataAxiosReplaceSMSParameter).then((data) => {
            if (data.status == 'Ok') {
              this.$mySweetDefaultTost('عملیات موفق', 'پیامک ها با موفقیت به صف ارسال پیامک اضافه شدند', 'success', 2000)

              //ارسال همه پیامکهای آماده به ارسال
              this.$SendSmsAmadeha()
            }
          })
        })
      }
    },
    GetAzaSearched(value) {
      this.OzvInfo = value
      this.FamilyName = this.OzvInfo.OzvName + ' ' + this.OzvInfo.OzvFamily
      // this.DataAxios.OzvName=this.$store.state[this.$route.name].OzvInfo.OzvName
      // this.DataAxios.OzvFamily=this.$store.state[this.$route.name].OzvInfo.OzvFamily
      this.DataAxios.ArryfildValue.ShomareOzv = this.OzvInfo.ShomareOzv
      // this.DataAxios.TblAzaId=this.$store.state[this.$route.name].OzvInfo.Id
      // this.DataAxios.Mobile=this.$store.state[this.$route.name].OzvInfo.Mobile
    },
    GetTaahodSearched(value) {
      console.log(this.DataAxios.ArryfildValue)
    },
    OpenModal(num) {
      this.$store.state.Modal = true
      this.ContentModal = num
    },
    ValueResultHoze(val) {
      this.DataAxios.ArryfildValue.TblAzaNoeId = val == null ? 0 : val.id
    },
    ValueResultNoeMoshtari(val) {
      this.DataAxios.ArryfildValue.TblTafsiliTypeId = val == null ? 0 : val.id
    },
    ValueResultVaziat(val) {
      this.DataAxios.ArryfildValue.TblComboIdVazeit12 = val == null ? 0 : val.id
    },
    Search() {
      try {
        this.DataAxios.Action = this.$route.name
        this.DataAxios.Method = 'post'
        this.$PostData(this.DataAxios)
          .then((data) => {
            if (data.data.length > 0) {
              this.posts = data.data
              if (this.posts != null) {
                let info
                let list = []
                for (let index = 0; index < this.posts.length; index++) {
                  info = this.posts[index]
                  info['row'] = index + 1
                  info.Selected = false
                  info.Ani == true
                  list.push(info)
                }
                this.rows = list
                this.config.pagination = true
              }
            } else {
              this.rows = []
              this.$mySweetDefaultTost('عدم وجود اطلاعات', 'اطلاعاتی وجود ندارد ', 'info', 2000)
            }
          })
          .finally(() => {
            this.GridKey++
          })
      } catch (error) {
        console.log(error)
      }
    },
    SelectRow(row) {
      let Find
      for (let index = 0; index < this.SelectedAza.length; index++) {
        if (this.SelectedAza[index].tblAzaId == row.tblAzaId) {
          Find = this.SelectedAza[index]
          break
        }
      }
      if (Find == null || Find == undefined) {
        row.Selected = true
        row.TarixErsal = this.Ani == true ? this.$GetJalaliDateTime() : this.Tarikh
        row.tblUserGrpInsert = this.$session.get('UserInfo').tblGrpId
        row.Ani = this.Ani
        this.SelectedAza.push(row)
      }
      // this.$store.state.renderComponent= false
      // this.$nextTick(()=>{
      //     this.$store.state.renderComponent= true
      // })
    },
    UnSelectRow(row) {
      for (let index = 0; index < this.SelectedAza.length; index++) {
        if (this.SelectedAza[index].tblAzaId == row.tblAzaId) {
          row.Selected = false
          this.SelectedAza.splice(index, 1)
        }
      }
      // this.$store.state.renderComponent= false
      // this.$nextTick(()=>{
      // this.$store.state.renderComponent= true
      // })
    },
    SelectNotMobile(row, IsMobile) {
      if (IsMobile == false) {
        this.$mySweetDefault('فیلد الزامی', 'برای عضو انتخابی شما شماره موبایل ثبت نشده ، ابتدا شماره موبایل عضو رو تکمیل و سپس اقدام به ارسال پیامک برای این عضو کنید.', 'error', 3000)
      }
    },
    SelectAll() {
      // console.log(this.SelectedAza);
      // console.log(this.rows);
      for (let index = 0; index < this.rows.length; index++) {
        if (this.rows[index].Mobile != '') {
          this.SelectRow(this.rows[index])
        }
      }
      this.GridKey++
    },
    UnSelectAll() {
      for (let index = 0; index < this.rows.length; index++) {
        if (this.rows[index].Selected == true) {
          this.rows[index].Selected = false
          this.UnSelectRow(this.SelectedAza[index])
        }
      }
      this.GridKey++

      this.SelectedAza = JSON.parse(JSON.stringify(this.EmptyArr))
    },
    Img() {
      return 'background-image:url("/img/pic/Mobile5.png");background-size: cover; height: 100vh; min-height: 75vh;background-repeat: no-repeat'
    },
    PreviewMsg(changeColorIcon) {
      return new Promise((success, errorFunction) => {
        if (changeColorIcon == true) {
          this.Preview = !this.Preview
          if (this.Preview == true) {
            if (this.Preview && this.SelectedAza.length > 0) {
              this.CopyTextSms = JSON.parse(JSON.stringify(this.TextSmsTemplate))
              this.SelectedAza[0].MatnSMS = this.TextSmsTemplate

              var DataAxiosReplaceSMSParameter = { ArryfildValue: { ListData: this.SelectedAza } }
              DataAxiosReplaceSMSParameter.Action = 'CashSmsPanel/ReplaceSMSPrm'
              DataAxiosReplaceSMSParameter.Method = 'post'
              this.$PostData(DataAxiosReplaceSMSParameter).then((data) => {
                this.TextSmsTemplate = data.result[0].matnSMS
                // if (data.status=="Ok") {
                //     //
                // }
              })
            }
          } else this.TextSmsTemplate = JSON.parse(JSON.stringify(this.CopyTextSms))
        } else {
          this.SelectedAza.forEach((element) => {
            element.MatnSMS = this.TextSmsTemplate
          })
          // this.SelectedAza[0].MatnSMS=
          // console.log(this.FardMotofareghe);
          this.FardMotofareghe.MatnSMS = this.TextSmsTemplate

          var DataAxiosReplaceSMSParameter = { ArryfildValue: { ListData: this.SelectedAza } }
          DataAxiosReplaceSMSParameter.Action = 'CashSmsPanel/ReplaceSMSPrm'
          DataAxiosReplaceSMSParameter.Method = 'post'
          this.$PostData(DataAxiosReplaceSMSParameter).then((data) => {
            // this.TextSmsTemplate=data.result
            success(data.result)

            // if (data.status=="Ok") {
            //     //
            // }
          })
        }
      })
    },
    SearchShomareozv(e) {
      if (e.key == 'Enter') {
        e.target.value = e.target.value.replace(this.$session.get('UserInfo').codeShobe.trim() + '-', '')
        e.target.value = e.target.value.padStart(6, 0)
        e.target.value = this.$session.get('UserInfo').codeShobe.trim() + '-' + e.target.value
        this.DataAxios.ArryfildValue.ShomareOzv = e.target.value
        var DataAxiosSerch = {
          ArryfildValue: {
            ShomareOzv: e.target.value,
            OzvFamilyName: '',
            Mobile: '',
            CodeMeli: '',
            Shenasname: '',
            OzvFamily: '',
            OzvName: '',
            Parvandeh: '',
          },
        }
        DataAxiosSerch.ArryfildValue.TblGrpId = this.$session.get('UserInfo').tblGrpId
        DataAxiosSerch.ArryfildValue.tblShobeId = this.$session.get('UserInfo').tblShobeId
        DataAxiosSerch.Action = 'vorodi'
        DataAxiosSerch.Method = 'post'
        this.$PostData(DataAxiosSerch).then((data) => {
          if (data.length > 0) {
            this.OzvInfo = data[0]
            this.FamilyName = data[0].OzvName + ' ' + data[0].OzvFamily
            this.Fkid = data[0].TblAzaId
          } else {
            this.DataAxios.ArryfildValue.ShomareOzv = ''
            this.FamilyName = ''
            this.$mySweetDefaultTost('عدم وجود اطلاعات', 'عضوی با شماره عضو وارد شده یافت نشد ', 'info', 3000)
          }
        })
      }
    },
  },
}
</script>
<style scoped>
.border-t-b {
  border-top: 2px dashed #b3b2b2;
  border-bottom: 2px dashed #b3b2b2;
}
.btn-circle {
  width: 30px;
  height: 30px;
  text-align: center;
  padding: 6px 0;
  font-size: 12px;
  line-height: 1.7285714295;
  border-radius: 15px;
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
  -ms-transform: rotate(-20deg); /* IE 9 */
  transform: rotate(-120deg);
}
#cin {
  overflow: auto;
  overflow-x: hidden;
}

#cin::-webkit-scrollbar-track {
  background-color: #e2e2e2;
}

#cin::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
}

#cin::-webkit-scrollbar-thumb {
  border-radius: 100px;
  background-color: #dca722;
}
.Show {
  transition: 1s;
  display: block;
}
.Hide {
  transition: 1s;
  display: none;
}
.Up {
  height: 30px;
  /* background:#a7a7a77b; */
  transition: all 1s !important;
}
.Down {
  /* background:#a7a7a77b; */
  transition: all 1s !important;
  height: 90px;
}
.Combo {
  transition: 1s;
  display: none;
}
.Weight {
  width: 91% !important;
}
.image {
  background-size: contain !important;
  /* background-image: url("/Template/NewMenu/img/Mobile5.png"); */
  min-height: 75vh;
  background-repeat: no-repeat;
}

.To:focus {
  background-color: #3a3a4100;
  /* border-color: #dca722;
    box-shadow: 0 1px 1px #dca722 inset, 0 0 8px #dca722; */
  border-color: none;
  box-shadow: none;
  border-bottom: 2px solid #dca722;
}
.UserImage {
  width: 30px;
}
.Box-Message {
  width: 98% !important;
  min-height: 20vh !important;
  /* background:rgb(255, 3, 3); */
  border-radius: 10px !important;
  border: 1px solid #dca722;
  background-color: #cccaca38;
  color: #ffffff;
  text-align: justify;
  resize: none !important;
}

.Box-Message:focus {
  border-color: none;
  box-shadow: none;
  outline: none !important;
}

/* Mobil */
@media (max-width: 767px) {
  .image {
    background-size: cover !important;
    /* background-image: url("./Image/back.jpg"); */
    min-height: 100vh;
    padding-left: 100px;
    background-repeat: no-repeat;
  }
}
/* Md Mode */
@media (min-width: 900px) and (max-width: 1440px) {
  .absolute {
    bottom: 26% !important;
  }
}
</style>
<style>
.vpd-time-column .vpd-counter input {
  font-size: 22px !important;
}
</style>
